const data = {
  title: "Floor 2-8",
  musicTrack: "MUSIC_WORLD2",
  theme: "GREEN",
  tilesWidth: 11,
  tilesHeight: 11,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 6,
      y: 2,
    },
    {
      type: "WATER",
      x: 11,
      y: 3,
    },
    {
      type: "WATER",
      x: 13,
      y: 3,
    },
    {
      type: "WATER",
      x: 5,
      y: 1,
    },
    {
      type: "WATER",
      x: 6,
      y: 1,
    },
    {
      type: "WATER",
      x: 7,
      y: 1,
    },
    {
      type: "WATER",
      x: 9,
      y: 1,
    },
    {
      type: "WATER",
      x: 9,
      y: 3,
    },
    {
      type: "WATER",
      x: 7,
      y: 3,
    },
    {
      type: "WATER",
      x: 6,
      y: 3,
    },
    {
      type: "WATER",
      x: 5,
      y: 3,
    },
    {
      type: "WATER",
      x: 13,
      y: 5,
    },
    {
      type: "WATER",
      x: 12,
      y: 5,
    },
    {
      type: "WATER",
      x: 11,
      y: 5,
    },
    {
      type: "WATER",
      x: 10,
      y: 5,
    },
    {
      type: "WATER",
      x: 9,
      y: 5,
    },
    {
      type: "WATER",
      x: 8,
      y: 5,
    },
    {
      type: "WATER",
      x: 4,
      y: 5,
    },
    {
      type: "WATER",
      x: 4,
      y: 7,
    },
    {
      type: "WATER",
      x: 1,
      y: 8,
    },
    {
      type: "WATER",
      x: 3,
      y: 8,
    },
    {
      type: "WATER",
      x: 4,
      y: 8,
    },
    {
      type: "WATER",
      x: 5,
      y: 8,
    },
    {
      type: "WATER",
      x: 7,
      y: 8,
    },
    {
      type: "WATER",
      x: 8,
      y: 8,
    },
    {
      type: "WATER",
      x: 8,
      y: 7,
    },
    {
      type: "WATER",
      x: 11,
      y: 1,
    },
    {
      type: "WATER",
      x: 13,
      y: 1,
    },
    {
      type: "WATER",
      x: 13,
      y: 2,
    },
    {
      type: "WATER",
      x: 11,
      y: 2,
    },
    {
      type: "WATER",
      x: 3,
      y: 12,
    },
    {
      type: "WATER",
      x: 1,
      y: 12,
    },
    {
      type: "WATER",
      x: 2,
      y: 12,
    },
    {
      type: "WATER",
      x: 4,
      y: 12,
    },
    {
      type: "WATER",
      x: 5,
      y: 12,
    },
    {
      type: "WATER",
      x: 6,
      y: 12,
    },
    {
      type: "WATER",
      x: 7,
      y: 12,
    },
    {
      type: "WATER",
      x: 8,
      y: 12,
    },
    {
      type: "WATER",
      x: 9,
      y: 8,
    },
    {
      type: "WATER",
      x: 11,
      y: 8,
    },
    {
      type: "LOCK",
      x: 12,
      y: 4,
      color: "BLUE",
    },
    {
      type: "WALL",
      x: 11,
      y: 4,
    },
    {
      type: "WALL",
      x: 9,
      y: 4,
    },
    {
      type: "WALL",
      x: 1,
      y: 4,
    },
    {
      type: "WALL",
      x: 3,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 5,
      y: 4,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "WALL",
      x: 7,
      y: 4,
    },
    {
      type: "WALL",
      x: 13,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 3,
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WATER",
      x: 5,
      y: 2,
    },
    {
      type: "WALL",
      x: 12,
      y: 3,
    },
    {
      type: "WALL",
      x: 12,
      y: 1,
    },
    {
      type: "WATER",
      x: 9,
      y: 7,
    },
    {
      type: "WATER",
      x: 11,
      y: 6,
    },
    {
      type: "WATER",
      x: 11,
      y: 7,
    },
    {
      type: "KEY",
      x: 10,
      y: 6,
      color: "BLUE",
    },
    {
      type: "LOCK",
      x: 10,
      y: 4,
      color: "GREEN",
    },
    {
      type: "WATER",
      x: 10,
      y: 3,
    },
    {
      type: "WATER",
      x: 9,
      y: 2,
    },
    {
      type: "WATER",
      x: 10,
      y: 2,
    },
    {
      type: "WATER",
      x: 10,
      y: 1,
    },
    {
      type: "CHIP",
      x: 10,
      y: 2,
    },
    {
      type: "WATER",
      x: 6,
      y: 8,
    },
    {
      type: "WATER",
      x: 12,
      y: 10,
    },
    {
      type: "KEY",
      x: 10,
      y: 10,
      color: "GREEN",
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 9,
      isRaised: true,
    },
    {
      type: "WALL",
      x: 11,
      y: 9,
    },
    {
      type: "WALL",
      x: 9,
      y: 9,
    },
    {
      type: "WALL",
      x: 9,
      y: 11,
    },
    {
      type: "WALL",
      x: 11,
      y: 11,
    },
    {
      type: "WALL",
      x: 11,
      y: 10,
    },
    {
      type: "WALL",
      x: 10,
      y: 11,
    },
    {
      type: "LOCK",
      x: 4,
      y: 6,
      color: "BLUE",
    },
    {
      type: "THIEF",
      x: 10,
      y: 8,
    },
    {
      type: "THIEF",
      x: 8,
      y: 6,
    },
    {
      type: "LOCK",
      x: 9,
      y: 10,
      color: "GREEN",
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 5,
      direction: "RIGHT",
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 7,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 7,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 5,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 7,
      direction: "DOWN",
    },
    {
      type: "WALL",
      x: 8,
      y: 9,
    },
    {
      type: "WALL",
      x: 8,
      y: 11,
    },
    {
      type: "LOCK",
      x: 8,
      y: 2,
      color: "BLUE",
    },
    {
      type: "WATER",
      x: 7,
      y: 2,
    },
    {
      type: "WALL",
      x: 8,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 1,
    },
    {
      type: "CONVEYOR",
      x: 8,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "WALL",
      x: 7,
      y: 9,
    },
    {
      type: "WALL",
      x: 5,
      y: 9,
    },
    {
      type: "WALL",
      x: 5,
      y: 11,
    },
    {
      type: "WALL",
      x: 6,
      y: 11,
    },
    {
      type: "WALL",
      x: 7,
      y: 11,
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 9,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 8,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 10,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "WALL",
      x: 6,
      y: 9,
    },
    {
      type: "WATER_PICKUP",
      x: 2,
      y: 6,
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "CHIP",
      x: 8,
      y: 10,
    },
    {
      type: "CHIP",
      x: 5,
      y: 10,
    },
    {
      type: "CHIP",
      x: 2,
      y: 10,
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 2,
      direction: "LEFT",
    },
    {
      type: "WALL",
      x: 3,
      y: 9,
    },
    {
      type: "WALL",
      x: 4,
      y: 9,
    },
    {
      type: "WALL",
      x: 4,
      y: 11,
    },
    {
      type: "WALL",
      x: 3,
      y: 11,
    },
    {
      type: "WALL",
      x: 1,
      y: 9,
    },
    {
      type: "WALL",
      x: 1,
      y: 10,
    },
    {
      type: "WALL",
      x: 1,
      y: 11,
    },
    {
      type: "WALL",
      x: 2,
      y: 11,
    },
    {
      type: "WATER",
      x: 1,
      y: 5,
    },
    {
      type: "WATER",
      x: 1,
      y: 6,
    },
    {
      type: "WATER",
      x: 1,
      y: 7,
    },
    {
      type: "WATER",
      x: 3,
      y: 7,
    },
    {
      type: "WATER",
      x: 3,
      y: 5,
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 4,
      direction: "DOWN",
    },
    {
      type: "WATER",
      x: 3,
      y: 6,
    },
    {
      type: "SWITCH",
      x: 6,
      y: 6,
    },
    {
      type: "THIEF",
      x: 6,
      y: 4,
    },
  ],
};

export default data;
